export const SET_COMMON_PROPS = "SET_COMMON_PROPS";
export const SET_COMMON_DATES = "SET_COMMON_DATES";
export const SET_COMPARE_OPTION = "SET_COMPARE_OPTION";
export const SET_CHANNELS = "SET_CHANNELS";
export const PAGE_COMMON_PROPS = "PAGE_COMMON_PROPS";
export const SET_COMMON_PROPS_NULL = "SET_COMMON_PROPS_NULL";
